import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { of } from 'rxjs';
import * as OT from '@opentok/client';
import { LoginService } from '../login/login.service';

@Injectable({
  providedIn: 'root',
})
export class OpentokService {
  readonly url: string = `${environment.backend.url}/VideoConsultaRN-PC/api/v1/gestionSalas`

  session: OT.Session

  constructor(
    private http: HttpClient,
    private loginService: LoginService
  ) { }

  public getOT() {
    return OT;
  }

  public doCreateRoom(garante: string, telefono:string, email: string) {
    const token = this.loginService.getToken();
    const payloadBase64 = token.split('.')[1];
    const payloadString = atob(payloadBase64);
    const payload = JSON.parse(payloadString);

    return this.http.post(this.url, { garante, telefono, email, usuario: payload.iss }, { withCredentials: true });
    //return of({urlmedico: 'https://bupadev-sanitas-dev.apigee.net/VideoConsultaRN-PC/api/v1/sala/598d6550b02d74f44237bac5/doctor'});
  }

  public doOpenSession(url) {
    return this.http.post(url, {}, { withCredentials: true });
  }

  public doInitSession(sessionId) {
    this.session = OT.initSession(environment.opentok.apikey, sessionId)
    return this.session;
  }
  
}